import style from "./home.module.css";
import Hero from "../../components/Hero/Hero";
import InfoCard from "../../components/InfoCard/InfoCard";
import Footer from "../../components/Footer/Footer";
import FAQComponent from "../../components/FAQ/FAQ";
import { useEffect } from "react";
import { useWebEngageTaraLandingView } from "../../hooks/webengage";
// import CreditTable from "../../components/CreditTable/CreditTable";
// import { useAppSelector } from "../../store/hooks";
const HomePage = () => {
  const { trackWebEngageTaraLandingView } = useWebEngageTaraLandingView();
  // const { wallet } = useAppSelector((state) => state.wallet);
  // const hasTaraWallet = wallet.data?.data?.exist!;
  // const token = useAppSelector((state) => state.config.token);
  useEffect(() => {
    trackWebEngageTaraLandingView();
  }, []);
  return (
    <div className={style.home}>
      <div className={style.inner}>
        <Hero />
        <InfoCard />
        <FAQComponent />
        {/* {token && <>{hasTaraWallet === false && <CreditTable />}</>} */}
        <Footer />
      </div>
    </div>
  );
};
export default HomePage;
